import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { PRODUCT_OPTIONS } from "../data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY = {
  name: "", company: "", phone: "", city: "",
  product: PRODUCT_OPTIONS[0], quantity: "", message: "",
};

const inputCls =
  "w-full bg-white border border-black/15 px-4 py-3.5 text-sm text-brand-ink placeholder:text-brand-ink/35 outline-none focus:border-brand-red transition-colors duration-300";

export const QuoteForm = ({ title = "REQUEST A QUOTE" }) => {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Enquiry sent. Our team will contact you shortly.");
      setForm(EMPTY);
    } catch {
      toast.error("Could not send your enquiry. Please call or WhatsApp us instead.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid="quote-form"
      className="bg-brand-mist border border-black/10 p-6 sm:p-9"
    >
      <h3 className="font-display text-2xl font-semibold uppercase tracking-tight text-brand-ink">
        {title}
      </h3>
      <div className="mt-2 h-px w-14 bg-brand-red" />
      <div className="mt-7 grid sm:grid-cols-2 gap-4">
        <input required value={form.name} onChange={set("name")} placeholder="Name *" data-testid="quote-name-input" className={inputCls} />
        <input value={form.company} onChange={set("company")} placeholder="Company" data-testid="quote-company-input" className={inputCls} />
        <input required value={form.phone} onChange={set("phone")} placeholder="Phone *" type="tel" data-testid="quote-phone-input" className={inputCls} />
        <input value={form.city} onChange={set("city")} placeholder="City" data-testid="quote-city-input" className={inputCls} />
        <select value={form.product} onChange={set("product")} data-testid="quote-product-select" className={inputCls}>
          {PRODUCT_OPTIONS.map((o) => (
            <option key={o} value={o}>{o}</option>
          ))}
        </select>
        <input value={form.quantity} onChange={set("quantity")} placeholder="Quantity (e.g. 50 frames)" data-testid="quote-quantity-input" className={inputCls} />
      </div>
      <textarea
        value={form.message}
        onChange={set("message")}
        placeholder="Message"
        rows={4}
        data-testid="quote-message-input"
        className={`${inputCls} mt-4 resize-none`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="quote-submit-btn"
        className="group mt-6 inline-flex w-full sm:w-auto items-center justify-center gap-2 bg-brand-red text-white text-sm font-semibold tracking-[0.14em] uppercase px-8 py-4 hover:bg-brand-ink disabled:opacity-60 transition-colors duration-300"
      >
        {loading ? "Sending..." : "Submit Enquiry"}
        {loading ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
        )}
      </button>
    </form>
  );
};
